const config = { API_KEY: "AIzaSyA8faJEyEJLo8QkFWHjvprH17SPVLJeO8Q" };

export { config };
